import React, { useState } from "react";
import { Grid } from "@mui/material";
import CardView from "../../../../components/common/CardView";
import dayjs from "dayjs";
import ManageStorage from "./ManageStorage";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

interface StorageLeadCardDetailsProps {
  leadDetails: any;
}

const StorageLeadCardDetails: React.FC<StorageLeadCardDetailsProps> = ({
  leadDetails,
}) => {
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: any) => state?.user);

  const [open, setOpen] = useState(false);
  const [selectedStorageLead, setSelectedStorageLead] = useState(null);

  const leadCardDetailsFields = [
    {
      title: "Customer Details",
      isEdit: true,
      name: leadDetails?.customer?.name || "Unknown",
      phone: leadDetails?.customer?.phone || "Phone Number",
      email: leadDetails?.customer?.email || "EMail",
    },
    {
      title: "Relevant Dates",
      isEdit: false,
      // movingOn: leadDetails?.movingOnDate
      //   ? `${dayjs(leadDetails?.movingOnDate).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")}${
      //       leadDetails?.movingOnEndDate
      //         ? ` - ${dayjs(leadDetails?.movingOnEndDate).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")}`
      //         : ""
      //     }`
      //   : "N/A",
      // packingOn: leadDetails?.packingOnDate
      //   ? dayjs(leadDetails?.packingOnDate).format(
      //       userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY",
      //     )
      //   : "N/A",
      followUp: leadDetails?.followUpDate
        ? dayjs(leadDetails?.followUpDate).format(
            userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY",
          )
        : "N/A",
    },
    {
      title: "Referrer",
      name: leadDetails?.referrer?.name || "Unknown",
      contact_name: leadDetails?.referrer?.contact_name || "Unknown",
      email: leadDetails?.referrer?.email || "EMail",
    },
  ];

  const handleEditStorageLead = (item: any) => {
    setOpen(true);
    setSelectedStorageLead(leadDetails);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <>
      {open && (
        <ManageStorage
          selectLead={selectedStorageLead}
          open={open}
          onHide={() => setOpen(false)}
          title={"Update Storage Lead"}
          screen="storage"
        />
      )}
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          marginTop: "2px",
          padding: "8px 0px",
        }}
      >
        {leadCardDetailsFields.map((item: any, i: number) => (
          <Grid
            key={i}
            item
            xs={12}
            md={4}
            style={{
              padding: "0px 4px",
              marginBottom: "10px",
              overflowWrap: "anywhere",
            }}
          >
            <CardView
              {...{
                ...item,
                isEdit: item?.isEdit,
                width: "100%",
                onEditClick: () => handleEditStorageLead(item),
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default StorageLeadCardDetails;
